import { render, staticRenderFns } from "./PluginConfirmDialog.vue?vue&type=template&id=81357d80&scoped=true&"
import script from "./PluginConfirmDialog.vue?vue&type=script&lang=js&"
export * from "./PluginConfirmDialog.vue?vue&type=script&lang=js&"
import style0 from "./PluginConfirmDialog.vue?vue&type=style&index=0&id=81357d80&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81357d80",
  null
  
)

export default component.exports